import React from 'react';
import { useNavigate } from 'react-router-dom';
import CustomLink from './CustomLink';
import fileDownload from 'js-file-download';
import Axios from 'axios';
import { toast } from 'react-toastify';
import { useState } from 'react';
import img from '../../assets/images/myLogo.png';

const Header = () => {
    const navigate = useNavigate();
    const [isDownloading, setIsDownloading] = useState(false);

    const download = () => {
        setIsDownloading(true);
        const url = 'https://my-portfolio-api-998g.onrender.com';
        Axios.get(url, {
            responseType: 'blob',
        }).then(res => {
            fileDownload(res.data, 'Shahariar_Rahman_Resume.pdf');
            setIsDownloading(false);
            toast.success('Download Complete 🙂', {
                position: toast.POSITION.TOP_LEFT,
                autoClose: 7000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                style: {
                    marginTop: '5rem',
                    color: '#00ff00',
                    background: '#00283a80',
                    fontFamily: 'font-play',
                    border: "1px solid #194151",
                    filter: "drop-shadow(16px 16px 20px #194170)",
                    marginLeft: '10px',
                    marginRight: '10px',
                    borderRadius: '7px'
                }
            });
        })
    }

    const nav = <>
        <div className='lg:mr-6 mb-1 font-play lg:mb-0 hover:bg-inherit' onClick={() => navigate("/home")}><CustomLink to="/home">Home</CustomLink></div>
        <div className='lg:mr-6 mb-1 font-play lg:mb-0 hover:bg-inherit' onClick={() => navigate("/skills")}><CustomLink to="/skills">Skills</CustomLink></div>
        <div className='lg:mr-6 mb-1 font-play lg:mb-0 hover:bg-inherit' onClick={() => navigate("/contact")}><CustomLink to="/contact">Contact</CustomLink></div>
        <div className='lg:mr-6 mb-1 font-play lg:mb-0 hover:bg-inherit' onClick={() => navigate("/blogs")}><CustomLink to="/blogs">Blogs</CustomLink></div>
    </>;

    return (
        // <nav className='border-b-[1px] border-b-[rgb(255,255,255,.15)] bg-gradient-to-r from-[rgb(2 ,22,43,.20)] via-[rgb(2 ,22,43,.20)] to-[rgba(0,0,0,0.40)] backdrop-blur-2xl sticky top-0 z-10'>
        <header className='border-b-[1px] border-b-[rgb(255,255,255,.15)] bg-[#02162b] sticky top-0 z-10'>
            <div className="navbar min-h-6 p-0 mx-auto font-medium text-white uppercase text-sm h-16">
                <div className="navbar-start">
                    <div className="dropdown">
                        <label tabIndex="0" className="btn btn-ghost lg:hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="inline-block w-5 h-5 stroke-current"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path></svg>
                        </label>
                        <ul tabIndex="0" className=" hmenu menu-compact glass bg-[#02162be1]  dropdown-content mt-3 p-2 shadow rounded-box w-52">
                            {nav}
                        </ul>
                    </div>
                    <div className="btn btn-ghost text-3xl cursor-default hover:transition-none hover:bg-inherit hidden sm:block capitalize">
                        <button onClick={() => navigate("/admin")} className="font-audiowide inline-flex items-center btn capitalize font-thin leading-6 text-xs shadow rounded-lg text-green-400 hover:text-white bg-[#00283a80] backdrop-blur-2xl hover:bg-[#00283a50] transition ease-in-out duration-150 w-28 border-[1px] border-gray-800 hover:border-gray-800" disabled="">
                            <div className='flex justify-center items-center'>
                                <img className='w-10 ml-2' src={img} alt="" />
                            </div>
                        </button>
                    </div>
                </div>
                <div className="navbar-center hidden lg:flex">
                    <ul className="menu menu-horizontal p-0 flex items-center">
                        {nav}
                    </ul>
                </div>
                <div className="navbar-end">
                    <div className="navbar-center lg:flex">
                        <ul className="menu menu-horizontal p-0">
                            <div className='mr-3 lg:mb-0 flex justify-center items-center'>
                                {isDownloading ?
                                    <>
                                        <div className='rounded-full mr-1'>
                                            <svg className="animate-spin h-6 w-12 text-green-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                        </div>
                                        <button
                                            onClick={download}
                                            type="button"
                                            className="font-audiowide inline-flex items-center btn capitalize font-semibold leading-6  text-[10px] sm:text-xs shadow rounded-tr-none rounded-br-2xl text-green-400 bg-[#00283a80] backdrop-blur-2xl hover:bg-[#00283a] transition ease-in-out duration-150 cursor-not-allowed w-40 border-[1px] border-green-900 animate-pulse">
                                            Downloading . . .
                                        </button>
                                    </>
                                    :
                                    <>
                                        {/* <div className='animate-bounce ring-1 ring-slate-200/20 shadow-lg rounded-full mr-4 mt-[7px]'>
                                            <svg
                                                className="h-6 w-12 text-green-500 -rotate-90"
                                                fill="none" strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                viewBox="-5 -6 34 37"
                                                stroke="currentColor"
                                            >
                                                <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
                                            </svg>
                                        </div> */}
                                        <button
                                            onClick={download}
                                            type="button"
                                            className="font-audiowide inline-flex items-center btn capitalize font-thin leading-6 text-[10px] sm:text-xs shadow rounded-tr-none rounded-br-2xl text-green-400 hover:text-white bg-[#00283a80] backdrop-blur-2xl hover:bg-green-600 transition ease-in-out duration-150 w-40 border-[1px] border-green-900" disabled=""
                                        >
                                            Download Resume
                                        </button>
                                    </>}
                            </div>
                        </ul>
                    </div>
                </div>
            </div >
        </header >
    );
};

export default Header;